import React, {
  useState,
  useEffect
} from "react";
import { useDebounce } from 'use-debounce';
import { useTranslation } from "react-i18next";
import {
  useDispatch,
  useSelector
} from "react-redux";

import {
  search,
  setSearchValue,
} from "store/actions/search";
import { Magnifier } from "icons";
import useFlags from "hooks/useFlags";
import { GAHandler } from "utils/GA";
import { Div } from "ui";

import {
  Container,
  Input,
  ClearBtn
} from "./styles";


const SearchBar = () => {
  const { t } = useTranslation();
  const [query, setQuery] = useState('')
  const dispatch = useDispatch();
  const { searchValue } = useSelector(state => state.searchReducer);
  const { isCommunitySectionEnabled } = useFlags()

  const [value] = useDebounce(query,1000)

  const handleChange = (e) => {
    setQuery(e.target.value)
    dispatch(setSearchValue(e.target.value))
  }

  const clearValue = () => dispatch(setSearchValue(""))

  useEffect(() => {
    if (!value) return
    const contentType = isCommunitySectionEnabled ? 'all' : 'series'
    dispatch(search({
      query: value,
      contentType
    }));

    GAHandler('content_search');

  },[value])

  useEffect(() => () => dispatch(setSearchValue('')), [dispatch])

  return (
    <Container htmlFor="search">
      <Div minWidth={20}>
        <Magnifier />
      </Div>
      <Input
        name="search"
        id="search"
        value={searchValue}
        placeholder={t("search-placeholder")}
        onChange={handleChange}
        autoComplete="off"
        autoFocus
      />
      {searchValue && <ClearBtn onClick={clearValue} />}
    </Container>
  );
};

export default SearchBar